module.exports = __webpack_public_path__ + "static/rcc-efficacy-desktop-c088b5e64e0a173fa3d7af3e3ac8146f.png";